import React, { useState, useEffect } from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import Header from "./components/header";
import Footer from "./components/footer";
import { createBrowserHistory } from "history";
import { Routers } from "./router";
import { connect } from "react-redux";
import RequestSite from "./components/fetch/site";
import AccessDenied from "./views/accessDenied";

//IMPORT CSS
import "./assets/style.css";

const hist = createBrowserHistory();

function App(props) {
  const [categories, setCategories] = useState([]);

  const getCategories = () => {
    const body = {
      query: `
        query {
          productCategories {
            name
            id
            isActive
            iconName
          }
        }
      `
    };
    RequestSite({ auth: null, body: JSON.stringify(body) })
      .then(({ productCategories }) => setCategories(productCategories))
      .catch(console.log);
  };

  useEffect(() => {
    getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Router history={hist}>
      <Header categories={categories} language={props.language} />
      <Switch>
        {Routers.map((router, i) =>
          props.isLogin || router.public ? (
            <Route
              key={i}
              path={router.link}
              render={() => <router.component language={props.language} />}
              exact
            />
          ) : (
            <Route
              key={i}
              path={router.link}
              render={() => <AccessDenied language={props.language} />}
              exact
            />
          )
        )}
        <Redirect from={"*"} to="/" />)
      </Switch>
      <Footer categories={categories} language={props.language} />
    </Router>
  );
}

const mapStateToProps = state => ({
  language: state.language,
  isLogin: state.user.isLogin
});

export default connect(
  mapStateToProps,
  null
)(App);
